import React from 'react';
import { TaskyConfirmDialog } from '../tasky';

interface DeleteConfirmDialogProps {
  isOpen: boolean;
  productName: string;
  onCancel: () => void;
  onConfirm: () => void;
}

const DeleteConfirmDialog: React.FC<DeleteConfirmDialogProps> = ({
  isOpen,
  productName,
  onCancel,
  onConfirm,
}) => (
  <TaskyConfirmDialog
    open={isOpen}
    onClose={onCancel}
    onConfirm={onConfirm}
    tone="destructive"
    title="商品を削除しますか？"
    description={
      <>
        「{productName}」を削除してもよろしいですか？
        <br />
        この操作は取り消せません。商品に関連するすべてのデータが削除されます。
      </>
    }
    confirmText="削除する"
    cancelText="キャンセル"
  />
);

export default DeleteConfirmDialog;
